import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { CameraDataStore } from "../../../store/store";
import { TextFieldInput } from "../../../../../components/form-inputs";
import { AuthStore } from "../../../../../store";

export interface CameraNameInputProps {
  cameraDataStore?: CameraDataStore;
  authStore?: AuthStore;
}

const InputStringMaximumLength = 249;

function CameraNameInput(props: CameraNameInputProps) {
  const cameraDataStore = props.cameraDataStore!;
  const { t } = useTranslation("camera-grid");
  const cameraName = cameraDataStore.selectedCamera.cameraName;
  const authStore = props.authStore!;
  const { errorMessages } = cameraDataStore;

  const isFieldDisabled = () => {
    if (!authStore.isAdmin()) return true;

    return false;
  };

  return (
    <TextFieldInput
      autoFocus
      mandatory
      disabled={isFieldDisabled()}
      value={cameraName}
      errorMessage={
        (errorMessages &&
          errorMessages["cameraName"] &&
          t("Required information")) ||
        ""
      }
      label={t("Camera").toUpperCase()}
      placeholder={t("Camera")}
      onChange={(event: any) => {
        if (!event.target.validity.valid) return;

        const cameraNameValue = event.target.value;
        if (cameraNameValue.length > InputStringMaximumLength) return;

        cameraDataStore.setSelectedCameraName(cameraNameValue);
        cameraDataStore.setValidated(false);
      }}
      onValueChangeDebounced={() => {
        cameraDataStore.validateSelectedCamera("cameraName");
        cameraDataStore.setValidated(true);
      }}
    />
  );
}

export default inject("cameraDataStore", "authStore")(observer(CameraNameInput));
